(() => {
  const updateSelectedLabels = (root, variant) => {
    if (!root || !variant?.options) return;

    const groups = [...root.querySelectorAll('[data-option-position]')]
      .sort((first, second) => Number(first.dataset.optionPosition) - Number(second.dataset.optionPosition));

    groups.forEach((group, index) => {
      const selectedLabel = group.querySelector('[data-option-selected]');
      if (selectedLabel) selectedLabel.textContent = variant.options[index] || '';
    });
  };

  const scrollToDescriptionFromLink = (event, link) => {
    const targetId = link.hash?.slice(1);
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const initProductRedesign = (root) => {
    if (!root || root.dataset.redesignReady === 'true') return;
    root.dataset.redesignReady = 'true';

    const variantsJson = root.querySelector('[data-product-variants-json]');
    const idInput = root.querySelector('[data-variant-id-input]');

    let variants = [];
    try {
      variants = JSON.parse(variantsJson?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const initialVariant = variants.find((variant) => String(variant.id) === String(idInput?.value || ''));
    if (initialVariant) updateSelectedLabels(root, initialVariant);

    root.addEventListener('click', (event) => {
      const descriptionLink = event.target.closest('[data-product-description-link]');
      if (descriptionLink && root.contains(descriptionLink)) {
        scrollToDescriptionFromLink(event, descriptionLink);
      }
    });

    root.addEventListener('cd13:variant-change', (event) => {
      updateSelectedLabels(root, event.detail?.variant);
    });
  };

  const init = (scope = document) => {
    const roots = scope.matches?.('[data-product-root]') ? [scope] : scope.querySelectorAll('[data-product-root]');
    roots.forEach(initProductRedesign);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
